module.exports = __webpack_public_path__ + "static/BlockchainNft-7e050f2a9ff8c3dc1cd725064451382b.png";